import {useEffect, useState} from "react";
import {getTicketByUniqueCode} from "../../services/Administrative/ticketsService";

export const useGetTicketByUniqueCode = (uniqueCode: string) => {
    const [ticket, setTicket] = useState<any>(null);
    const [loadingTicket, setLoadingTicket] = useState<boolean>(false);

    const updatePerformedActionsLocally = (updatedPerformedActions: string[]) => {
        setTicket((prevTicket: any) => {
            if (!prevTicket) return prevTicket;
            return {...prevTicket, performedActions: updatedPerformedActions};
        });
    };

    const updateTicketState = async (newState: string, ticketUniqueCode: string) => {
        if (!ticket || ticket.uniqueCode !== ticketUniqueCode) return;

        setTicket((prevTicket: any) => ({
            ...prevTicket,
            ticketState: newState
        }));

    };


    useEffect(() => {
        const fetchTicketByUniqueCode = async () => {
            setLoadingTicket(true);
            try {
                const response = await getTicketByUniqueCode(uniqueCode);
                setTicket(response.ticket)
            } catch (error) {
                console.error('Error fetching ticket:', error);
            } finally {
                setLoadingTicket(false);
            }
        };
        fetchTicketByUniqueCode();
    }, []);

    return {ticket, loadingTicket, updatePerformedActionsLocally, updateTicketState};
};
